import React from 'react';
import './icons.css';
import {
  HiHome,
  HiSparkles,
  HiMap,
  HiUserGroup,
  HiClipboardDocumentList,
  HiMoon,
  HiMegaphone,
  HiChartBarSquare,
  HiLink,
  HiPhoto,
  HiCircleStack,
  HiBars3,
  HiCurrencyDollar,
  HiCube,
  HiPlay,
  HiGift,
  HiBuildingOffice2,
  HiArrowTopRightOnSquare,
  HiStar,
} from 'react-icons/hi2';

const ICONS = {
  home: HiHome,
  sparkles: HiSparkles,
  about: HiSparkles,
  map: HiMap,
  roadmap: HiMap,
  community: HiUserGroup,
  users: HiUserGroup,
  list: HiClipboardDocumentList,
  clipboard: HiClipboardDocumentList,
  moon: HiMoon,
  megaphone: HiMegaphone,
  announcement: HiMegaphone,
  chart: HiChartBarSquare,
  dashboard: HiChartBarSquare,
  link: HiLink,
  photo: HiPhoto,
  media: HiPhoto,
  image: HiPhoto,
  bubble: HiCircleStack,
  menu: HiBars3,
  coin: HiCurrencyDollar,
  token: HiCurrencyDollar,
  gem: HiCube,
  nft: HiCube,
  gamepad: HiPlay,
  play: HiPlay,
  candy: HiGift,
  mission: HiGift,
  building: HiBuildingOffice2,
  external: HiArrowTopRightOnSquare,
  star: HiStar,
};

/** Maps legacy emoji values from CMS/DB to icon keys */
const EMOJI_TO_ICON = {
  '🏠': 'home',
  '💫': 'sparkles',
  '🗺️': 'map',
  '🫧': 'bubble',
  '📋': 'list',
  '🌙': 'moon',
  '📢': 'megaphone',
  '📊': 'chart',
  '🔗': 'link',
  '🖼️': 'photo',
  '👥': 'users',
  '🪙': 'coin',
  '💎': 'gem',
  '🎮': 'gamepad',
  '✨': 'sparkles',
  '🍬': 'candy',
};

export function resolveIconName(name, emoji) {
  if (name && ICONS[name]) return name;
  if (emoji && EMOJI_TO_ICON[emoji]) return EMOJI_TO_ICON[emoji];
  if (name && EMOJI_TO_ICON[name]) return EMOJI_TO_ICON[name];
  return 'sparkles';
}

export default function GumballIcon({ name, emoji, className = '', size = 20 }) {
  const key = resolveIconName(name, emoji);
  const Icon = ICONS[key] || HiStar;
  return <Icon className={`gb-icon ${className}`.trim()} size={size} aria-hidden="true" />;
}
